/* eslint-disable react/forbid-prop-types */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import VariantColumn from "./VariantColumn";
import EvidenceColumn from "./EvidenceColumn";
import DiseaseColumn from "./DiseaseColumn";
import InformationColumn from "./InformationColumn";
import DrugsAndEvidenceStatementColumn from "./DrugsAndEvidenceStatementColumn";
import PublicationLinks from "../../../components/Publications/components/PublicationLinks";

import {
  getVarsomeHost,
  getGenomeName,
} from "../../../state/selectors/general.selectors";
import { starColors } from "./helpers";

const { any, arrayOf, number, shape, string } = PropTypes;

const getRatingStars = (rating) => {
  const stars = [];
  const color = starColors[rating];
  for (let i = 0; i < rating; i++) {
    stars.push(
      <i className="varsome-icons icon-star" style={{ color }} key={i} />
    );
  }
  return stars;
};

const getRepresentativeTranscript = (
  representativeTranscript,
  hostUrl,
  genomeName
) => {
  if (representativeTranscript) {
    return (
      <div>
        <a
          href={`${hostUrl}/transcript/${genomeName}/${representativeTranscript}`}
        >
          {representativeTranscript}
        </a>
      </div>
    );
  }
  return "-";
};

const ClinicalEvidencesTableColumns = (props) => {
  const { item, label, isGene, hostUrl, genomeName } = props;
  const {
    pub_med_references: articles,
    representative_transcript,
    rating,
    disease,
    phenotypes,
    variant,
    drugs,
    drug_interaction_type: drugInteractionType,
    last_review_date: lastReviewDate,
    nct_ids: nctIds,
    asco_entry: ascoEntry,
    variant_summary: variantSummary,
    variant_origin: variantOrigin,
    variant_civic_url: variantCivicUrl,
    evidence_statement: evidenceStatement,
  } = item;
  switch (label) {
    case "variant":
      return (
        <VariantColumn
          variant={variant}
          variantSummary={variantSummary}
          variantOrigin={variantOrigin}
          variantCivicUrl={variantCivicUrl}
          isGene={isGene}
        />
      );
    case "pub_med_references":
      return (
        <>
          {(articles || []).map((x) => (
            <PublicationLinks ids={[String(x)]} key={x} />
          ))}
        </>
      );

    case "evidence_type":
      return (
        <EvidenceColumn
          evidenceUrl={item.evidence_civic_url}
          evidenceType={item.evidence_type}
          evidenceLevel={item.evidence_level}
          evidenceStatus={item.evidence_status}
          evidenceDirection={item.evidence_direction}
        />
      );
    case "info":
      return (
        <InformationColumn
          variant={item.variant}
          variantUrl={item.variant_civic_url}
          lastReviewDate={lastReviewDate}
          nctIds={nctIds}
          ascoEntry={ascoEntry}
        />
      );
    case "disease":
      return <DiseaseColumn disease={disease} phenotypes={phenotypes} />;
    case "drugs":
      return (
        <DrugsAndEvidenceStatementColumn
          drugs={drugs}
          drugInteractionType={drugInteractionType}
          evidenceStatement={evidenceStatement}
        />
      );
    case "representative_transcript":
      return getRepresentativeTranscript(
        representative_transcript,
        hostUrl,
        genomeName
      );
    case "rating":
      return getRatingStars(rating);
    default:
      return item[label] || "-";
  }
};

ClinicalEvidencesTableColumns.propTypes = {
  item: shape({
    asco_entry: any,
    clinical_significance: string,
    disease: string,
    doid: string,
    drug_interaction_type: any,
    drugs: any,
    entrez_id: string,
    evidence_civic_url: string,
    evidence_direction: string,
    evidence_level: string,
    evidence_statement: string,
    evidence_status: string,
    evidence_type: string,
    gene: string,
    gene_civic_url: string,
    gene_description: string,
    last_review_date: string,
    nct_ids: any,
    normalized_drug: any,
    phenotypes: any,
    pub_med_references: arrayOf(number),
    rating: string,
    representative_transcript: any,
    transcripts: any,
    variant: string,
    variant_civic_url: string,
    variant_origin: string,
    variant_summary: any,
  }),
  label: PropTypes.string,
  isGene: PropTypes.bool,
  hostUrl: PropTypes.string,
  genomeName: PropTypes.string,
};

ClinicalEvidencesTableColumns.defaultProps = {
  item: null,
  label: null,
  isGene: false,
  hostUrl: null,
  genomeName: null,
};

const mapStateToProps = (state) => ({
  hostUrl: getVarsomeHost(state),
  genomeName: getGenomeName(state),
});

export default connect(mapStateToProps)(ClinicalEvidencesTableColumns);
